import React, { useEffect } from "react";
import GlobalLoading from "../../components/common/GlobalLoading";

const WithLoginLayout = (Content, showGoTo = false) => {
  return function WithContent({ ...props }) {
    useEffect(() => {
      document.body.classList.remove("overflowHidden");
    }, []);
    
    return (
      <>
        <GlobalLoading />
        <section className="content-login">
          <figure className="thumb-login">
            <img
              src={require("../../ui/img/img-login.jpg")}
              className="hidden lg:block"
              alt="Imagen login"
            />
            <img
              src={require("../../ui/img/img-login-responsive.jpg")}
              className="block lg:hidden"
              alt="Imagen login"
            />
          </figure>
          <div className="section-login">
            <div className="flex items-center justify-between relative">
              <a href="#!" className="hidden lg:block">
                <img
                  src={require("../../ui/img/logo-afp.png")}
                  className="w-[200px] h-14 object-contain"
                  alt="Logo Afp"
                />
              </a>
              {showGoTo && (
                <a
                  href="https://www.afpcrecer.com.do"
                  className="btn btn-secondary btn-medium absolute right-8 hidden lg:inline-flex"
                >
                  Ir a Website
                </a>
              )}
            </div>
            <div className="block pt-0 lg:pt-[104px]">
              <Content />
            </div>
          </div>
        </section>
      </>
    );
  };
};

export default WithLoginLayout;
